import styled from 'styled-components';

export const StyledWebNavbar = styled.nav`
  padding: 20px 24px;
  margin-bottom: 32px;
  background-color: #ffffff;
  border: 1px solid #ebebeb;
  border-radius: 16px;
  display: none;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 64px;
  position: sticky;
  top: 38px;
  .nav-dr-name {
    color: #4e4e4e;
    font-size: 16px;
    font-family: 'dana-bold';
  }
  .medical-num-text {
    font-size: 12px;
    color: #4e4e4e;
    font-family: 'dana-bold';
    display: grid;
    grid-template-columns: 105px auto;
    align-items: center;
  }
  .medical-num {
    margin-right: auto;
    font-size: 16px;
    color: #753cbe;
  }
  @media screen and (min-width: 1024px) {
    display: flex;
  }
`;
